<template>
  <div class="checkbox" :class="{ disabled: disabled, white: white }">
    <div class="checkbox__rules">
      <input
        :disabled="disabled"
        class="checkbox-input"
        type="checkbox"
        :id="id"
        :value="value"
        v-model="proxyModel"
        @change="$emit('change')"
      />
      <label
        :for="id"
        class="checkbox__label"
        :class="{ 'checkbox__label-disabled': disabled }"
      ></label>
      <div>
        <span
          class="checkbox__text"
          :class="{ 'checkbox__text-crossed': disabled }"
          @click="changeCheckbox"
        >
          {{ label }}&nbsp;</span
        >
        <a
          v-if="href"
          @click="stopEventIfDisabled"
          target="_blank"
          :href="href"
        >
          {{ linkLabel }}
        </a>
      </div>
    </div>
    <div v-if="validError" class="error help-block help-block-error">
      Необходимо дать согласие
    </div>
  </div>
</template>

<script>
import { computed, toRefs } from 'vue'

export default {
  name: 'FormInputCheckbox',
  emits: ['change', 'update:modelValue'],
  props: {
    id: {
      type: [String, Number],
      required: true,
      default: ''
    },
    modelValue: {
      type: [Boolean, Number, Array],
      required: true,
      default: false
    },
    validError: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    linkLabel: {
      type: String,
      required: false,
      default: ''
    },
    href: {
      type: String,
      required: false,
      default: ''
    },
    white: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },

  setup (props, { emit }) {
    const { disabled, modelValue } = toRefs(props)

    const stopEventIfDisabled = (event) => {
      if (disabled.value) {
        event.preventDefault()
      }
    }

    const changeCheckbox = () => {
      if (!disabled.value) {
        // Переключаем значение чекбокса
        proxyModel.value = !proxyModel.value
      }
    }

    const proxyModel = computed({
      get () {
        return modelValue.value
      },
      set (val) {
        emit('update:modelValue', val)
      }
    })

    return {
      stopEventIfDisabled,
      proxyModel,
      changeCheckbox
    }
  }
}
</script>

<style scoped>
.checkbox__rules {
  color: black;
  margin-bottom: 8px;
  line-height: 16px;
}
.checkbox__rules {
  display: flex;
}
.checkbox.white .checkbox__rules {
  color: white;
}
.checkbox a {
  color: #002856;
  text-decoration: underline;
}
.checkbox.white a {
  color: white;
  text-decoration: underline;
}
.checkbox input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}
.checkbox label {
  padding-right: 10px;
  padding-left: 0 !important;
  position: relative;
  cursor: pointer;
}
.checkbox label:before {
  content: "";
  -webkit-appearance: none;
  background-color: transparent;
  border-radius: 2px;
  border: 1px solid #808080;
  padding: 7px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
}
.checkbox.white label:before {
  background-color: white;
}
.checkbox input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  left: 6px;
  top: 3px;
  width: 6px;
  height: 11px;
  border: solid #002856;
  border-radius: 1px;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.checkbox.disabled {
  color: #bac7de;
}
.checkbox.disabled a {
  color: #bac7de;
}
.checkbox.disabled label {
  color: #bac7de;
}
.checkbox.disabled input:checked + label:after {
  border: solid #bac7de;
  border-radius: 1px;
  border-width: 0 3px 3px 0;
}
.checkbox__text {
  cursor: pointer;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #002856;
}
.checkbox__label-disabled:before {
  content: "";
  -webkit-appearance: none;
  background-color: #e1e1e1 !important;
  border-radius: 2px;
  border: 1px solid #808080;
  padding: 7px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
}

.checkbox__text-crossed {
  text-decoration: line-through;
}
</style>
